import { Button, DialogActions, DialogContent, Typography } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react';
import WarningIcon from '../../../src/components/LoaderImg/Avatar.svg';

type Props = {
  close: any;
  handleDelete: any;
  title: string;
  message: string;
  isDisabled: boolean;
  buttontext?: string
};

const CommonConfirmDeleteModal = (props: Props) => {
  const { close, handleDelete, title, message, isDisabled, buttontext = 'Delete' } = props;
  
  return (
    <Box p={3}>
      <>
        <DialogContent>
          <Box sx={{ display: 'flex' }}>
            <Box p={1}>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  height: '100%',
                  marginRight: '12px',
                }}
              >
                <img
                  alt=""
                  src={WarningIcon}
                />
              </div>
            </Box>
            <Box>
              <Typography variant="h5">{title}</Typography>
              <Typography
                sx={{ color: '#6C737F', fontWeight: '400', width: '100%' }}
                variant="body2"
                mt={0.2}
              >
                {message} 
              </Typography>
            </Box>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            autoFocus
            sx={{ color: '#111927' }}
            onClick={close}
          >
            Cancel
          </Button>
          <Button
            autoFocus
            variant="contained"
            sx={{
              background: '#F04438',
              color: '#fff',
              '&:hover': {
                background: '#F04438',
              },
            }}
            onClick={handleDelete}
            disabled={isDisabled}
          >
            {buttontext}
          </Button>
        </DialogActions>
      </>
    </Box>
  );
};

export default CommonConfirmDeleteModal;
